// Survey UI app
//
//  Copyright (c) 2025 MX8 Inc
//  All rights reserved.
//
//  This software is confidential and proprietary information of MX8.
//  You shall not disclose such Confidential Information and shall use it only
//  in accordance with the terms of the agreement you entered into with MX8.
import { Box, Grow, SxProps } from "@mui/material";
import React from "react";
import { OthersRankSorterProps } from "../../../util/types";
import { useThemeContext } from "../../../globalContext/global-context";
import { commonContainer, commonWrapper } from "../styles";
import { imageStyle, textContent } from "./styles";
import { CommonImageComp, Hints } from "../../ui";

const OthersRankSorter: React.FC<OthersRankSorterProps> = ({
  timerImageOPen,
  message,
  scrollToBottom,
}) => {
  const { globalObject } = useThemeContext();
  const appTheme = globalObject.themeData.normalizedTheme;
  const wrapperStyle: SxProps = commonWrapper(
    appTheme,
    message.self,
    !!timerImageOPen,
  );

  return (
    <Grow in data-testid="others-rank-sorter" style={{ width: "100%" }}>
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <Box sx={commonContainer(appTheme, message.self)}>
          <Box sx={wrapperStyle} data-testid="others-rank-sorter-wrapper">
            {/* c8 ignore next */}
            {(message.type === "text" ||
              (message.type === "rank-sort" && !message.self)) &&
            message.content ? (
              <Hints
                text={message.content.toString()}
                sx={textContent(appTheme, {
                  ...message,
                  error_message: undefined,
                })}
                testId="others-rank-sorter-content"
                variant="label"
              />
            ) : null}

            {message.error_message && !message.self && (
              <Hints
                text={message.error_message}
                sx={textContent(appTheme, message)}
                testId="others-rank-sorter-error"
                variant="error"
              />
            )}

            {message?.image && (
              <CommonImageComp
                currentVal={{
                  image: message?.image,
                  alt_text: message?.alt_text,
                }}
                imageStyle={imageStyle(appTheme)}
                imageTestid="render-image"
                onLoad={scrollToBottom}
              />
            )}
          </Box>
        </Box>
      </Box>
    </Grow>
  );
};

export default OthersRankSorter;
